import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import Logo from "../assets/logo.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setOpen(false);
  };

  return (
    <>
      {/* NAVBAR */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md shadow-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* LEFT - LOGO */}
            <Link to="/" onClick={scrollToTop}>
              <img src={Logo} alt="logo" className="h-12 md:h-14" />
            </Link>

            {/* CENTER - DESKTOP MENU */}
            <div className="hidden md:flex space-x-8">
              <Link to="/" className="nav-link" onClick={scrollToTop}>
                Home
              </Link>
              <Link to="/about" className="nav-link">
                About
              </Link>
              <Link to="/services" className="nav-link">
                Services
              </Link>
              <a href="/#section-products" className="nav-link">
                Products
              </a>

              <Link to="/responsibilities" className="nav-link">
                Responsibilities
              </Link>
            </div>

            {/* RIGHT SIDE */}
            <div className="flex items-center gap-3">
              {/* BUTTON (desktop only) */}
              <Button className="hidden md:flex bg-emerald-700 hover:bg-emerald-800 text-white rounded-full px-6">
                <Link to="/contact" onClick={scrollToTop}>
                  Contact
                </Link>
              </Button>

              {/* HAMBURGER (ALWAYS FAR RIGHT) */}
              <button
                onClick={() => setOpen(true)}
                className="md:hidden ml-auto"
              >
                <Menu className="h-7 w-7 text-gray-700" />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* BACKDROP */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          className="fixed inset-0 bg-black/40 z-40"
        />
      )}

      {/* DRAWER MENU */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-white z-50 shadow-2xl transform transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <img src={Logo} alt="logo" className="h-10" />

          <button onClick={() => setOpen(false)}>
            <X className="h-6 w-6 text-gray-700" />
          </button>
        </div>

        {/* LINKS */}
        <div className="flex flex-col p-6 space-y-6 text-gray-700 font-medium">
          <Link to="/" onClick={() => setOpen(false)}>
            Home
          </Link>
          <Link to="/about" onClick={() => setOpen(false)}>
            About
          </Link>

          <Link to="/services" onClick={() => setOpen(false)}>
            Services
          </Link>

          <a href="/#section-products" onClick={() => setOpen(false)}>
            Products
          </a>

          <Link to="/responsibilities" onClick={() => setOpen(false)}>
            Responsibilities
          </Link>

          <Button className="bg-emerald-700 hover:bg-emerald-800 text-white rounded-full w-full mt-4">
            <Link to="/contact" onClick={() => setOpen(false)}>
              Contact
            </Link>
          </Button>
        </div>
      </div>

      {/* STYLES */}
      <style>{`
        .nav-link {
          color: #374151;
          font-weight: 500;
          transition: 0.3s;
        }
        .nav-link:hover {
          color: #047857;
        }
      `}</style>
    </>
  );
};

export default Navbar;
